import { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';
import { cn } from '@/lib/utils/cn';

export interface BreadcrumbItem {
  label: ReactNode;
  href?: string;
  current?: boolean;
}

interface AppBreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

export function AppBreadcrumb({ items, className }: AppBreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className={cn('flex items-center text-xs font-semibold text-slate-400', className)}>
      <ol className="flex items-center gap-2">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const isCurrent = item.current ?? isLast;

          return (
            <li key={`breadcrumb-${index}`} className="flex items-center gap-2">
              {item.href && !isCurrent ? (
                <Link
                  to={item.href}
                  className="transition-colors hover:text-slate-600 dark:hover:text-slate-200"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={cn(isCurrent ? 'text-slate-900 dark:text-white' : undefined)}>
                  {item.label}
                </span>
              )}
              {!isLast && (
                <span className="material-symbols-outlined text-[14px] text-slate-300">chevron_right</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
